import { Tabs } from 'radix-ui';
import { SmallButton } from '../../gui/components/SmallButton';
import { Icon } from '../../gui/Icon';
import { HotkeyHint } from '@game-libs/exc-libs';
import { UpgradeConfigKey } from '../../types/game-types';
import styles from './styles.module.scss';

type UpgradesSelectorListProps = {
  tabListIds: string[];
  selectedElement: UpgradeConfigKey;
  hasPurchasableMap: Record<string, boolean>;
  generatorPurchasedMap: Record<string, boolean>;
};

const UpgradesSelectorItem = ({
  generatorId,
  index,
  isSelected,
  hasPurchasable,
  isEnabled,
}: {
  generatorId: string;
  index: number;
  isSelected: boolean;
  hasPurchasable: boolean;
  isEnabled: boolean;
}) => {
  return (
    <Tabs.Trigger
      asChild
      key={generatorId}
      disabled={!isEnabled}
      className={`radix-tabs-trigger ${styles.selectorButton}`}
      data-testid={`upgrades-tree-menu-tab-${generatorId}`}
      value={generatorId}
      // Because of a weird bug where the 1st element can't be selected right after opening the list
      style={{ display: generatorId === 'BUG_HIDE' ? 'none' : 'inherit' }}
    >
      <div className={styles.selectorButtonWrapper}>
        <SmallButton type={isSelected ? 'stamp_red' : 'stamp'}>
          <Icon hasBackground={false} xl iconId={generatorId} type={'upgrades'} />
          <HotkeyHint hint={index} />
          {hasPurchasable && (
            <div className={styles.purchasableIndicator}>
              <Icon iconId="exclamation" />
            </div>
          )}
        </SmallButton>
      </div>
    </Tabs.Trigger>
  );
};

export const UpgradesSelectorList = ({
  tabListIds,
  selectedElement,
  hasPurchasableMap,
  generatorPurchasedMap,
}: UpgradesSelectorListProps) => {
  return (
    <>
      {tabListIds.map((generatorId, index) => {
        return (
          <UpgradesSelectorItem
            key={generatorId}
            generatorId={generatorId}
            index={index}
            isSelected={selectedElement === generatorId}
            hasPurchasable={!!hasPurchasableMap[generatorId]}
            isEnabled={!!generatorPurchasedMap[generatorId]}
          />
        );
      })}
    </>
  );
};
